const tabTypes = {
  door: 'door',
  glass: 'glass',
  woody: 'woody',
  wall: 'wall',
  splits: 'splits',
};

export default tabTypes;
